import dayjs from 'dayjs';
import { SubscriptionApiType } from '../types/api/SubscriptionApiType';

export const noDeliveryTimeText = '指定なし';

/**
 * お届け内容変更モーダルを作成
 * @param subscription
 * @param master
 */
export const createChangeDeliveryDateModal = (subscription: SubscriptionApiType) => {
  const disableWeek = [
    subscription.shop.disableDeliveryDaysSun,
    subscription.shop.disableDeliveryDaysMon,
    subscription.shop.disableDeliveryDaysTue,
    subscription.shop.disableDeliveryDaysWed,
    subscription.shop.disableDeliveryDaysThr,
    subscription.shop.disableDeliveryDaysFri,
    subscription.shop.disableDeliveryDaysSat,
  ];

  // 指定可能なお届け時間
  const enableDeliveryTimes = [
    { tag: '', title: noDeliveryTimeText },
    ...subscription.shop.deliveryTimes,
  ];

  return {
    nextDeliveryDate: dayjs(subscription.nextDeliveryDate).toDate(),
    deliveryTime: subscription.deliveryTime ?? '',
    disableWeek,
    enableDeliveryTimes,
    nextBillingDate: subscription.nextBillingDate,
  };
};
